





import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { SortSetting } from '@/util/SortUtils';
import StyledSelect, { StyledSelectData } from '@/views/common/StyledSelect.vue';

@Component({
  components: {StyledSelect},
})
export default class SortSelection extends Vue {
  @Prop({required: true})
  private sortOptions!: SortSetting[];

  @Model('change', {type: String})
  private currentSortSetting!: string;

  get wrappedSortOptions(): Array<StyledSelectData<SortSetting>> {
    return this.sortOptions.map((option) => ({
      displayString: this.$t('message.sort.' + option.messageCode).toString(),
      key: option.id,
      value: option,
    }));
  }

  get selectedOption(): StyledSelectData<SortSetting> | null {
    return this.wrappedSortOptions.find((option) => option.value.id === this.currentSortSetting) ?? null;
  }

  public onSortSelect(displayName: string, setting: SortSetting) {
    this.$emit('change', setting.id);
  }
}
